import { Component, OnInit } from '@angular/core';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { Platform, MenuController } from '@ionic/angular';

@Component({
  selector: 'app-about',
  templateUrl: './about.page.html',
  styleUrls: ['./about.page.scss'],
})
export class AboutPage implements OnInit {

  headingtitle : any;
  langcontext: any;
  version:any;

  constructor(public platform: Platform,public cmndef: CommonDefinitionService, public menuCtrl: MenuController, public cmndecl: CommonDeclarationService,) { 
    this.platform.ready().then(()=>{
      if (this.cmndecl.LanguageJson) {
        this.langcontext = this.cmndecl.LanguageJson.pages[0]['about_form'];
      } else {
        this.cmndecl.LanguageJson = JSON.parse(localStorage.languageJson);
        this.langcontext = this.cmndecl.LanguageJson['pages'][0].about_form;
      }
      this.headingtitle = this.langcontext.heading.text;
      
      if(this.cmndecl.buildflg == true)
        this.version = this.langcontext.version.label+ " "+this.cmndecl.versionNo+" "+this.langcontext.build.label+" "+ this.cmndecl.buildNo;
      else
        this.version = this.langcontext.version.label+ " "+this.cmndecl.versionNo;
        console.log(this.version);
    });
  }

  ionViewWillEnter () {
    this.menuCtrl.swipeEnable(false);
  }

  ngOnInit() {
  }

}
